import React, { FC, useMemo } from 'react'
import Carousel from 'nuka-carousel'

export interface StepCarouselProps {
  current: string
  steps: Array<{
    id: string
    step: JSX.Element
  }>
}

export const StepCarousel: FC<StepCarouselProps> = ({ steps, current }) => {
  const currentIndex = useMemo(() => steps.findIndex(({ id }) => id === current), [current, steps])

  const handleAfterSlide = () => {
    window.scrollTo(0, 0)
  }

  return (
    <Carousel
      slideIndex={currentIndex}
      transitionMode={'fade'}
      withoutControls={true}
      heightMode={'current'}
      dragging={false}
      swiping={false}
      style={{ outline: 'none' }}
      frameOverflow="inherit"
      afterSlide={handleAfterSlide}
    >
      {steps.map(({ step }) => step)}
    </Carousel>
  )
}
